import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as SharedActions from '@states/shared/shared.actions';
import { catchError, debounceTime, exhaustMap, mergeMap, of, share, switchMap } from 'rxjs';
import { OrganizationService } from '../../development/organization.service';
import { UtilsService } from '../../edge/utils.service';
import { SupportOrganizationLogActions } from '@states/support-organization-log/support-organization-log.actions-types';
import { withLatestFrom } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import { AppState } from '../app.state';
import { getSupportOrgLogsFail } from '@states/support-organization-log/support-organization-log.actions';

@Injectable()
export class SupportOrganizationLogEffects {


  public beforeGetSupportOrgLogs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SupportOrganizationLogActions.beforeGetSupportOrgLogs),
      switchMap(({ filters }) => [
        SupportOrganizationLogActions.setSupportOrgLogsLoader({ loading: true }),
        SupportOrganizationLogActions.getSupportOrgLogs({ filters }),
      ]),
      share(),
    ),
  );

  public getSupportOrgLogs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SupportOrganizationLogActions.getSupportOrgLogs),
      withLatestFrom(this.store$.pipe(select(state => state.supportOrganizationLogState))),
      switchMap(([{ filters }, { isLastPage, latestTs }]) => {
        if (!isLastPage) {
          return this.organizationService.getSupportOrgLogs(filters, latestTs)
            .pipe(
              mergeMap(documents => {
                return [
                  SupportOrganizationLogActions.getSupportOrgLogsSuccess({ documents }),
                ];
              }),
              catchError(response => {
                const message = this.utilsService.errMessage(response);
                return [
                  SupportOrganizationLogActions.getSupportOrgLogsFail(),
                  SharedActions.consoleMessage({ error: message }),
                ];
              }),
            );
        } else {
          return of(SharedActions.doNothing());
        }
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private organizationService: OrganizationService,
    private utilsService: UtilsService,
    private store$: Store<AppState>,
  ) {
  }

}
